import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomCenter = styled(Center)`
    & .carousel-root {
        width: 100%;
    }

    & .carousel .control-dots {
        & .dot {
            width: 16px;
            height: 16px;
            box-shadow: none;
        }
    }
`;

export const CustomButton = styled(Button)`
    width: auto;
    margin-left: 36px;
    ${FONT("cormorant", 16, 700)}
    padding:0 12px;
    color: ${({ theme }) => theme.COLOR.black};
    background: ${({ theme }) => theme.COLOR.white};

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        margin-left: 20px;
    }
`;
